export const VoiceLanguage = {
  English: 'en'
}
export function convertFileIdToDownloadURI(language, fileIds) {
  const map = {}
  for (let key in fileIds) {
    map[key] =
      'https://trusty-static-source.oss-ap-southeast-1.aliyuncs.com/audio/' +
      language +
      '/' +
      fileIds[key]
  }
  return map
}
